import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as offersActions from '@store/offers/offers.actions';
import * as offersSelectors from '@store/offers/offers.selectors';
import { Observable } from 'rxjs';
import { IAvailableOffers, Offers, PreviewOffer } from '../core/models/offers.model';

@Injectable({ providedIn: 'root' })
export class OffersFacade {
  public offers$: Observable<Offers[]>;
  public amount$: Observable<string>;
  public previewOffers$: Observable<PreviewOffer[]>;
  public previewOffer$: Observable<PreviewOffer>;
  public isLoading$: Observable<boolean>;
  public offerQuantity$: Observable<number>;
  public numberOfInstallments$: Observable<number>;
  public availableOffers$: Observable<IAvailableOffers>;
  public previousInstallmentsSelected$: Observable<number>;

  constructor(private _store: Store) {
    this.amount$ = this._store.select(offersSelectors.selectAmount);
    this.offers$ = this._store.select(offersSelectors.selectOffers);
    this.isLoading$ = this._store.select(offersSelectors.selectIsLoading);
    this.previewOffers$ = this._store.select(offersSelectors.selectPreviewOffer);
    this.previewOffer$ = this._store.select(offersSelectors.selectDefaultPreviewOffer);
    this.offerQuantity$ = this._store.select(offersSelectors.selectOfferQuantity);
    this.numberOfInstallments$ = this._store.select(offersSelectors.selectNumberOfInstallments);
    this.availableOffers$ = this._store.select(offersSelectors.selectAvailableOffers);
    this.previousInstallmentsSelected$ = this._store.select(
      offersSelectors.selectPreviousInstallmentsSelected
    );
  }

  public sendDeviceId() {
    this._store.dispatch(offersActions.sendDeviceId());
  }

  // Offer by Merchant
  public getOffersByMerchant() {
    this._store.dispatch(offersActions.getOffersByMerchant());
  }

  public getOfferPreview(offersRequest: Array<Observable<PreviewOffer>>) {
    this._store.dispatch(offersActions.getOfferPreview({ offersRequest }));
  }

  public setOfferAmount(amount: string) {
    this._store.dispatch(offersActions.setOfferAmount({ amount }));
  }

  public setPreviewOffer(previewOffer: PreviewOffer) {
    this._store.dispatch(offersActions.setPreviewOffer({ previewOffer }));
  }

  public setSelectedOfferId(offerId: string) {
    this._store.dispatch(offersActions.setSelectedOfferId({ offerId }));
  }

  public getOneOfferPreview() {
    this._store.dispatch(offersActions.getOneOfferPreview());
  }

  public setOfferLoading() {
    this._store.dispatch(offersActions.setOfferLoading());
  }

  public setNumberOfInstallments(numberOfInstallments: number) {
    this._store.dispatch(offersActions.setNumberOfInstallments({ numberOfInstallments }));
  }

  public getAvailableOffers(transactionId: string) {
    this._store.dispatch(offersActions.getAvailableOffers({ transactionId }));
  }

  public setSortedAvailableOffers(offers: Offers[]) {
    this._store.dispatch(offersActions.successSetSortedAvailableOffers({ offers }));
  }

  public sendNewOfferIdForMaxInstallment(offerId: string) {
    this._store.dispatch(offersActions.sendNewOfferIdForMaxInstallment({ offerId }));
  }

  public setPreviousInstallmentsSelected(previousInstallmentsSelected: number) {
    this._store.dispatch(
      offersActions.setPreviousInstallmentsSelected({ previousInstallmentsSelected })
    );
  }
}
